webpackJsonp([114276838955818,60335399758886],{

/***/ 111:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"ATI"}}},"layoutContext":{}}

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(187);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(111);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var cleanProps = function cleanProps(props) {
	  var initialState = props.initialState,
	      getInitialState = props.getInitialState,
	      refs = props.refs,
	      getRefs = props.getRefs,
	      didMount = props.didMount,
	      didUpdate = props.didUpdate,
	      willUnmount = props.willUnmount,
	      getSnapshotBeforeUpdate = props.getSnapshotBeforeUpdate,
	      shouldUpdate = props.shouldUpdate,
	      render = props.render,
	      rest = _objectWithoutProperties(props, ["initialState", "getInitialState", "refs", "getRefs", "didMount", "didUpdate", "willUnmount", "getSnapshotBeforeUpdate", "shouldUpdate", "render"]);
	
	  return rest;
	};
	
	var Component = function (_React$Component) {
	  _inherits(Component, _React$Component);
	
	  function Component() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Component);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Component.prototype.getArgs = function getArgs() {
	    var state = this.state,
	        props = this.props,
	        setState = this._setState,
	        forceUpdate = this._forceUpdate,
	        refs = this._refs;
	
	    return {
	      state: state,
	      props: cleanProps(props),
	      refs: refs,
	      setState: setState,
	      forceUpdate: forceUpdate
	    };
	  };
	
	  Component.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.didMount) this.props.didMount(this.getArgs());
	  };
	
	  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    if (this.props.shouldUpdate) return this.props.shouldUpdate({
	      props: this.props,
	      state: this.state,
	      nextProps: cleanProps(nextProps),
	      nextState: nextState
	    });else return true;
	  };
	
	  Component.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.props.willUnmount) this.props.willUnmount({
	      state: this.state,
	      props: cleanProps(this.props),
	      refs: this._refs
	    });
	  };
	
	  Component.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
	    if (this.props.didUpdate) this.props.didUpdate(Object.assign(this.getArgs(), {
	      prevProps: cleanProps(prevProps),
	      prevState: prevState
	    }), snapshot);
	  };
	
	  Component.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps, prevState) {
	    if (this.props.getSnapshotBeforeUpdate) {
	      return this.props.getSnapshotBeforeUpdate(Object.assign(this.getArgs(), {
	        prevProps: cleanProps(prevProps),
	        prevState: prevState
	      }));
	    } else {
	      return null;
	    }
	  };
	
	  Component.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        render = _props.render;
	
	    return render ? render(this.getArgs()) : typeof children === "function" ? children(this.getArgs()) : children || null;
	  };
	
	  return Component;
	}(_react2.default.Component);
	
	Component.defaultProps = {
	  getInitialState: function getInitialState() {},
	  getRefs: function getRefs() {
	    return {};
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = this.props.initialState || this.props.getInitialState(this.props);
	  this._refs = this.props.refs || this.props.getRefs(this.getArgs());
	
	  this._setState = function () {
	    return _this2.setState.apply(_this2, arguments);
	  };
	
	  this._forceUpdate = function () {
	    return _this2.forceUpdate.apply(_this2, arguments);
	  };
	};
	
	 false ? Component.propTypes = {
	  initialState: _propTypes.object,
	  getInitialState: _propTypes.func,
	  refs: _propTypes.object,
	  getRefs: _propTypes.func,
	  didMount: _propTypes.func,
	  didUpdate: _propTypes.func,
	  willUnmount: _propTypes.func,
	  getSnapshotBeforeUpdate: _propTypes.func,
	  shouldUpdate: _propTypes.func,
	  render: _propTypes.func,
	  children: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.node])
	} : void 0;
	exports.default = Component;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var react = __webpack_require__(1);
	var PropTypes = _interopDefault(__webpack_require__(3));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var callAll = function () {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return fns.forEach(function (fn) {
	      return fn && fn.apply(undefined, args);
	    });
	  };
	};
	var noop = function () {};
	
	var Toggle = function (_Component) {
	  inherits(Toggle, _Component);
	
	  function Toggle() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Toggle);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      on: _this.getOn({ on: _this.props.defaultOn })
	    }, _this.getTogglerProps = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return _extends({
	        'aria-expanded': Boolean(_this.getOn()),
	        tabIndex: 0
	      }, props, {
	        onClick: callAll(props.onClick, _this.toggle)
	      });
	    }, _this.toggleKeys = ['Enter', ' '], _this.getInputTogglerProps = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return _this.getTogglerProps(_extends({}, props, {
	        onKeyUp: callAll(props.onKeyUp, function (event) {
	          if (event.key === 'Enter') {
	            // <input> already respond to Enter
	            _this.toggle();
	          }
	        })
	      }));
	    }, _this.getElementTogglerProps = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return _this.getTogglerProps(_extends({}, props, {
	        onKeyUp: callAll(props.onKeyUp, function (event) {
	          if (_this.toggleKeys.indexOf(event.key) > -1) {
	            _this.toggle();
	          }
	        })
	      }));
	    }, _this.setOnState = function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !_this.getOn();
	
	      var cb = _this.getOn() === state ? noop : function () {
	        _this.props.onToggle(state, _this.getTogglerStateAndHelpers());
	      };
	      _this.setState({ on: state }, cb);
	    }, _this.setOn = _this.setOnState.bind(_this, true), _this.setOff = _this.setOnState.bind(_this, false), _this.toggle = _this.setOnState.bind(_this, undefined), _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Toggle.prototype.getOn = function getOn() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	
	    return this.isOnControlled() ? props.on : state.on;
	  };
	
	  Toggle.prototype.isOnControlled = function isOnControlled() {
	    return this.props.on !== undefined;
	  }; // This matches <button> behavior
	
	  Toggle.prototype.getTogglerStateAndHelpers = function getTogglerStateAndHelpers() {
	    return {
	      on: this.getOn(),
	      getTogglerProps: this.getTogglerProps,
	      getInputTogglerProps: this.getInputTogglerProps,
	      getElementTogglerProps: this.getElementTogglerProps,
	      setOn: this.setOn,
	      setOff: this.setOff,
	      toggle: this.toggle
	    };
	  };
	
	  Toggle.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var on = _ref.on;
	
	    if (on !== this.props.on && on !== this.state.on) {
	      this.setOnState(on);
	    }
	  };
	
	  Toggle.prototype.render = function render() {
	    var renderProp = unwrapArray(this.props.children);
	    return renderProp(this.getTogglerStateAndHelpers());
	  };
	
	  return Toggle;
	}(react.Component);
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array
	 * otherwise returns the argument
	 * @param {*} arg the maybe-array
	 * @return {*} the arg or it's first item
	 */
	
	
	Toggle.defaultProps = {
	  defaultOn: false,
	  onToggle: noop
	};
	 false ? Toggle.propTypes = {
	  defaultOn: PropTypes.bool,
	  on: PropTypes.bool,
	  onToggle: PropTypes.func,
	  children: PropTypes.oneOfType([PropTypes.func, PropTypes.array]).isRequired
	} : void 0;
	function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	}
	
	module.exports = Toggle;


/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navbar = function Navbar() {
	  return _react2.default.createElement(_reactRouterDom.Route, {
	    render: function render(_ref) {
	      var location = _ref.location;
	      return _react2.default.createElement(
	        'footer',
	        { className: 'c-footer t-context--dark' },
	        _react2.default.createElement(
	          'nav',
	          {
	            className: (0, _classnames2.default)('c-footer__nav', {
	              'c-footer__nav--alpha': location.pathname === '/'
	            })
	          },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', className: 'c-footer__logo' },
	            _react2.default.createElement(
	              'svg',
	              { viewBox: '0 0 193.2 48.2', width: 140, height: 35 },
	              _react2.default.createElement('path', {
	                fill: '#00304D',
	                d: 'M50 31.7c0 .4-.4.8-.8.8h-1.7c-1.4-.2-3.1-1-3.1-3v-3.3c0-.4.4-.8.8-.8h3.9c.5 0 .8.4.8.8v5.5h.1zm12.3-19.3c1.2-1.3 1.8-3 1.9-4.8a8 8 0 0 0-16.1 0 8 8 0 0 0 1.1 4h-5.4v-10C43.8 1 42.5.5 41 .5h-7.1c-1.6 0-2.8.5-2.8 1.1v19.7A16.6 16.6 0 1 0 21.9 45c.2.5.6.9 1.1.9h38.2c.5 0 .9-.7.9-1.6V12.4h.2z'
	              }),
	              _react2.default.createElement('path', {
	                fill: '#FFF',
	                d: 'M58.7 43.9h-5.3c-.7 0-1.3-.9-1.3-2.1V17.4c0-1.1.4-2.1 1.3-2.1a7 7 0 0 0 5.3 0c.7 0 1.3.9 1.3 2.1v24.3c-.1 1.3-.6 2.2-1.3 2.2m0 0h-5.3c-.7 0-1.3-.9-1.3-2.1V17.4c0-1.1.4-2.1 1.3-2.1a7 7 0 0 0 5.3 0c.7 0 1.3.9 1.3 2.1v24.3c-.1 1.3-.6 2.2-1.3 2.2zm-9.1-9.2c-4.8.5-7.3-1.9-7.3-4.6V23h7c.3 0 .6-.6.6-1.4v-6.2c0-.7-.3-1.4-.6-1.4h-7V3.4c0-.6-.9-1-2-1h-5.1c-1.1 0-2 .5-2 1V30c0 14.1 14 14.7 16.5 14.4.2 0 .4 0 .4-.6 0-5 .3-8.3-.5-9.1m0 0c-4.8.5-7.3-1.9-7.3-4.6V23h7c.3 0 .6-.6.6-1.4v-6.2c0-.7-.3-1.4-.6-1.4h-7V3.4c0-.6-.9-1-2-1h-5.1c-1.1 0-2 .5-2 1V30c0 14.1 14 14.7 16.5 14.4.2 0 .4 0 .4-.6 0-5 .3-8.3-.5-9.1zm6.7-32.5a5.6 5.6 0 0 0-5.6 5.5 5.6 5.6 0 0 0 5.7 5.5c3-.1 5.5-2.5 5.5-5.5 0-3.1-2.5-5.5-5.6-5.5m0 0a5.6 5.6 0 0 0-5.6 5.5 5.6 5.6 0 0 0 5.7 5.5c3-.1 5.5-2.5 5.5-5.5 0-3.1-2.5-5.5-5.6-5.5zM31.1 29.3a14.6 14.6 0 1 0-14.7 14.5h.1c2.1 0 4.2-.5 6.1-1.4v.6c0 .5.5.9 1.3.9h6c.7 0 1.3-.4 1.3-.9l-.1-13.7m0 0a14.6 14.6 0 1 0-14.7 14.5h.1c2.1 0 4.2-.5 6.1-1.4v.6c0 .5.5.9 1.3.9h6c.7 0 1.3-.4 1.3-.9l-.1-13.7zm23.3-11.8l-.1.8v21.9c0 .8.2 1.6.5 1.6h2.8c.3 0 .5-.7.5-1.6V18.4l-.1-.8c-.6.2-1.2.2-1.9.2-.5 0-1.1 0-1.7-.3zm-6.6 19.3a7.4 7.4 0 0 1-7.6-7.2v-9.1h6.9c.3 0 .6-.3.6-.6v-2.7c0-.3-.3-.6-.6-.6h-6.9V5c0-.4-.4-.6-.7-.6h-3.2c-.4 0-.7.3-.7.6v23.5c.2 7.3 3.2 12.1 11.9 13.5.4.1.8-.1.8-.5 0-3.6.2-4.1-.5-4.7zm8.5-32.7c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6.1-2-1.5-3.6-3.5-3.6zm.9 40.3v.2h.5v1h.3v-1h.4v-.2h-1.2zm2.4 0l-.3.8-.2-.8h-.4v1.3h.2v-1l.3 1h.3l.3-1v1h.2v-1.3h-.4zM25.5 29.2l.1-.1h.2l-.1.1h-.2zm-.3 2.9l.1-.1-.1.1zm-.1.2l.1-.1-.1.1zm-1.5 5.2l.1-.1-.1.1zm-.5.2l.1-.1-.1.1zm-6.9-1.5h.1l.1-.1-.2.1zm-8.7-4.6v.1-.1zm-.3-.7l.1.1-.1-.1zm17.1-3l-.1-.1.1.1zm-.1.1l-.1.1.1-.1zm-1.6 3.3l-.1.1.1-.1zm-6.8-4.4zm11.7-.3v-.2h-.2v-.1h-.1l-.1-.3-.1-.3-.2-.1v.1h-.3l-.3.1v.7H26v.1l-.6.1-.5.1h-.1l-.1.1-.2.1v.1l-.1.1.1-.1V27l-.1.1h-.1l-.2.1H24l.1.1h-.4l-.4.2-.1.1-.1.5h.3v.3l-.1.1-.1.1-.1.1H23l.1-.1.1-.1.1-.1.1-.1h-.5l-.1.1h-.2l-.1.1v.1H22v-.2h.2V27.8l-.3.2h-.1l-.1.1v.1-.2l.1-.1v-.5h-.1l-.4-.2h-.4v.2-.1l-.1.1v.5l.1.1v.4l-.1.2-.1.1v.1l-.2.4-.1.1h-.1v-.1l-.1-.2v-.6l.1-.1v-.6l.1-.1v-.2l-.1.1v.2l-.1.1v-.2l.1-.2.1-.1h.1v.1l.1-.1h.2v-.1h.4V27H21v-.1h-.9l-.1-.1v-.1l-.1-.1h-.1v-.1l.1-.1h-.2l-.1.1-.1.1h-.1l-.1.1H19l-.1.1h-.2v-.2l-.2.1h-.2v-.1l.2-.2.3-.2h.1l.1-.1h-.7V26h-.5v-.1l-.1-.2v.2h-2.2l-.8-.7-.3-.1H14l-.3-.1-.3-.1-.3-.1-.3-.1h-.2l-.3-.1-.3-.1-.3-.1-.4-.1-.6-.2-.5-.1-.2-.1-.2-.1-.3-.1-.3-.1-.3-.1v.5l-.2.1h-.1V24l.1-.1v-.1h-.1l-.1-.1h-.3l-.1-.1v-.1V24.3v-.1.1l.1.1.1.1-.1-.1h-.1v.2l-.4.5-.1.1-.1.3v.1l-.1.1h-.1l-.1.1v.2l-.1.2v.4l-.1.1-.1.1-.1.4h-.1v1.1l.1.2V28.8v-.1h.1l.1.2h-.1v.1-.2.4H7v.2h-.1v.1l.1.2v.2l.1.1v.4l.1.1.1.3v.2l.1.1v.2h.1l.1.1v.1l.1.1v.5l.9.2 1.4 1 .8.2.3.1v-.2l.7.1.1.1v.1l.1.1v.2l.1.2.2.2.1.4.1.2.1.1.2.2.2.1.2-.3h.5l.1.1.1.1v.1l.1.1.1.4.1.2.1.2.1.1.1.4.1.2.1.1h.1l.1.1h.2l.2.1h.1V36.4h.1v-.1h.2v.1l.1-.1h.2l.1-.1v-.3.1h.1l.2-.1h.4l.2.1h.5l.1.1v.1h.1l.1.1h.6l.1-.1h.2l.1.1h.2v-.1l.5-.8h-.1v-.1l.1-.1v-.1h-.1V35h-.2l-.1-.1v-.1h.5l.1-.1h.4l.1-.2v.2h.2l.1-.1v.1h.5l.2.1v.1h.2l.1-.1h.3l.1.1v.1l.1.1h.2v.6-.1.4l.1.1.1.1v.1h.1l.1.2v.1h.2l.1-.1h.1v-1.2l-.1-.1v-.4l-.2-.2-.1-.3.4.5v-.4l.1-.2V34h.3l.2-.2v-.1h.1V33.4l.1-.1h.1l.1-.1v-.1l.1-.1.1-.1h.1l.1-.1V32.5h-.2v-.2.1h.1v.1-.6h-.2v-.1H24v-.3l.1-.1v-.1V31.6h.2v.5-.2l.1-.2v-.3l.7-1-.1-.2-.1-.2v-.1h.6v.1V29.1h.1l.1-.1h.3l.2-.1.1-.1v-.1.1h.1l.1-.1h.1l.1-.1v-.1.1h-.2v-.2h-.1v-.1l-.1-.1v-.1l.1-.1v-.7h.1v-.1h.1l.8-.4.1-.2z'
	              }),
	              _react2.default.createElement('path', {
	                fill: '#E11F32',
	                d: 'M29.1 29.2a12.2 12.2 0 0 0-12.3-12A12 12 0 0 0 4.6 29a12 12 0 0 0 11.8 12.2h.5a13 13 0 0 0 6.7-1.9v2.5l.1.1h5.2l.1-.1v-11l.1-1.6m25.3-11.7l-.1.8v21.9c0 .8.2 1.6.5 1.6h2.8c.3 0 .5-.7.5-1.6V18.4l-.1-.8c-.6.2-1.2.2-1.9.2-.5 0-1.1 0-1.7-.3m-6.6 19.3a7.4 7.4 0 0 1-7.6-7.2v-9.1h6.9c.3 0 .6-.3.6-.6v-2.7c0-.3-.3-.6-.6-.6h-6.9V5c0-.4-.4-.6-.7-.6h-3.2c-.4 0-.7.3-.7.6v23.5c.2 7.3 3.2 12.1 11.9 13.5.4.1.8-.1.8-.5 0-3.6.1-4.1-.5-4.7m8.5-32.7c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6.1-2-1.5-3.6-3.5-3.6M29.1 29.2a12.2 12.2 0 0 0-12.3-12A12 12 0 0 0 4.6 29a12 12 0 0 0 11.8 12.2h.5a13 13 0 0 0 6.7-1.9v2.5l.1.1h5.2l.1-.1v-11l.1-1.6z'
	              }),
	              _react2.default.createElement('path', {
	                fill: '#FFF',
	                d: 'M25.499999999999996 29.200000000000003l.1-.1h.2l-.1.1h-.2zm-.3 2.9l.1-.1-.1.1zm-.1.2l.1-.1-.1.1m-1.5 5.2l.1-.1-.1.1m-.5.2l.1-.1-.1.1m-6.9-1.5h.1l.1-.1-.2.1zm-8.6-4.8zm-.1.2v.1-.1m-.3-.7l.1.1-.1-.1M24.3 27.9l-.1-.1.1.1zm-.1.1l-.1.1.1-.1zm-1.6 3.3l-.1.1.1-.1zm-6.8-4.4zm11.7-.3v-.2h-.2v-.1h-.1l-.1-.3-.1-.3-.2-.1v.1h-.3l-.3.1v.7H26v.1l-.6.1-.5.1h-.1l-.1.1-.2.1v.1l-.1.1.1-.1V27l-.1.1h-.1l-.2.1H24l.1.1h-.4l-.4.2-.1.1-.1.5h.3v.3l-.1.1-.1.1-.1.1H23l.1-.1.1-.1.1-.1.1-.1h-.5l-.1.1h-.2l-.1.1v.1H22v-.2h.2V27.8l-.3.2h-.1l-.1.1v.1-.2l.1-.1v-.5h-.1l-.4-.2h-.4v.2-.1l-.1.1v.5l.1.1v.4l-.1.2-.1.1v.1l-.2.4-.1.1h-.1v-.1l-.1-.2v-.6l.1-.1v-.6l.1-.1v-.2l-.1.1v.2l-.1.1v-.2l.1-.2.1-.1h.1v.1l.1-.1h.2v-.1h.4V27H21v-.1h-.9l-.1-.1v-.1l-.1-.1h-.1v-.1l.1-.1h-.2l-.1.1-.1.1h-.1l-.1.1H19l-.1.1h-.2v-.2l-.2.1h-.2v-.1l.2-.2.3-.2h.1l.1-.1h-.7V26h-.5v-.1l-.1-.2v.2h-2.2l-.8-.7-.3-.1H14l-.3-.1-.3-.1-.3-.1-.3-.1h-.2l-.3-.1-.3-.1-.3-.1-.4-.1-.6-.2-.5-.1-.2-.1-.2-.1-.3-.1-.3-.1-.3-.1v.5l-.2.1h-.1V24l.1-.1v-.1h-.1l-.1-.1h-.3l-.1-.1v-.1V24.3v-.1.1l.1.1.1.1-.1-.1h-.1v.2l-.4.5-.1.1-.1.3v.1l-.1.1h-.1l-.1.1v.2l-.1.2v.4l-.1.1-.1.1-.1.4h-.1v1.1l.1.2V28.8v-.1h.1l.1.2h-.1v.1-.2.4H7v.2h-.1v.1l.1.2v.2l.1.1v.4l.1.1.1.3v.2l.1.1v.2h.1l.1.1v.1l.1.1v.5l.9.2 1.4 1 .8.2.3.1v-.2l.7.1.1.1v.1l.1.1v.2l.1.2.2.2.1.4.1.2.1.1.2.2.2.1.2-.3h.5l.1.1.1.1v.1l.1.1.1.4.1.2.1.2.1.1.1.4.1.2.1.1h.1l.1.1h.2l.2.1h.1V36.4h.1v-.1h.2v.1l.1-.1h.2l.1-.1v-.3.1h.1l.2-.1h.4l.2.1h.5l.1.1v.1h.1l.1.1h.6l.1-.1h.2l.1.1h.2v-.1l.5-.8h-.1v-.1l.1-.1v-.1h-.1V35h-.2l-.1-.1v-.1h.5l.1-.1h.4l.1-.2v.2h.2l.1-.1v.1h.5l.2.1v.1h.2l.1-.1h.3l.1.1v.1l.1.1h.2v.6-.1.4l.1.1.1.1v.1h.1l.1.2v.1h.2l.1-.1h.1v-1.2l-.1-.1v-.4l-.2-.2-.1-.3.4.5v-.4l.1-.2V34h.3l.2-.2v-.1h.1V33.4l.1-.1h.1l.1-.1v-.1l.1-.1.1-.1h.1l.1-.1V32.5h-.2v-.2.1h.1v.1-.6h-.2v-.1H24v-.3l.1-.1v-.1V31.6h.2v.5-.2l.1-.2v-.3l.7-1-.1-.2-.1-.2v-.1h.6v.1V29.1h.1l.1-.1h.3l.2-.1.1-.1v-.1.1h.1l.1-.1h.1l.1-.1v-.1.1h-.2v-.2h-.1v-.1l-.1-.1v-.1l.1-.1v-.7h.1v-.1h.1l.8-.4m0-.1'
	              }),
	              _react2.default.createElement('path', {
	                id: 'type',
	                fill: '#FFF',
	                d: 'M193.2 37.7v-1c0-1.9-1.1-3.5-3.2-3.5a3 3 0 0 0-3.3 2.7V43a3 3 0 0 0 2.9 3.2h.4c1.6.2 3-1 3.2-2.6v-1.9H191v1.6c0 .8-.3 1.3-1.1 1.3s-1.1-.5-1.1-1.4v-6.4c0-1 .3-1.4 1.1-1.4.5 0 1.1.5 1.1 1.6v1h2.2zm-7.8 8.3v-1.9h-3.3V33.4h-2.2V46h5.5zm-6.8 0v-1.9h-3.3V33.4H173V46h5.6zm-11.3-2.1h-2.1V46h.8l-.8 2.2h1l1.3-2.2v-2.1h-.2zm-3.2 2.1v-1.9h-3.3V33.4h-2.2V46h5.5zm-11.4-2.7h2.4l.3 2.9h2.1l-2.4-12.6h-2.7L150 46.1h2.1l.6-2.8zm1.1-7.3l1 5.4H153l.8-5.4zm-9.5 10v-8l2.7 8h1.9V33.4H147v7.2l-2.5-7.2h-2.1V46h1.9zm-8.4-9.4c0-1 .3-1.4 1.1-1.4s1.1.5 1.1 1.4V43c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-6.4zm-2.3 6.4a3.4 3.4 0 0 0 3.5 3.2 3.4 3.4 0 0 0 3.2-3.2v-6.5a3.4 3.4 0 0 0-3.5-3.2 3.4 3.4 0 0 0-3.2 3.2V43zm-2.4-9.6H129V46h2.2V33.4zM123.3 46h2.2V35.3h2.1v-1.9h-6.4v1.9h2.1V46zm-6.7-2.7h2.4l.3 2.9h2.1L119 33.6h-2.7L114.2 46h2.1l.3-2.7zm1.3-7.3l1 5.4h-1.7l.7-5.4zm-9.5 10v-8l2.7 7.9h1.9V33.4h-1.9v7.2l-2.5-7.2h-2.1V46h1.9zm-8.6-5.1h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.4-1.1 1.4-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2h-.1zm0-5.7h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9h-.8v-3.8zM96 46v-1.9h-3.8v-3.7h2.7v-1.9h-2.7v-3.2h3.7v-1.9h-5.7V46H96zm-11.5 0h2.2V35.3h2.1v-1.9h-6.4v1.9h2.1V46zm-7.9 0v-8l2.7 7.9h1.9V33.4h-1.9v7.2l-2.5-7.2h-2.2V46h2zm-4.5-12.6h-2.2V46h2.2V33.4zm102.1-16.2a3 3 0 0 0-3-3c-2.1 0-3.3 1.1-3.3 3.2 0 3.7 4.4 4.3 4.4 6.8 0 .8-.5 1.1-1.3 1.1-.6 0-1.3-.6-1.3-1.9l-2.1.3c.2 1.9 1.3 3.5 3.2 3.5 2.1 0 3.3-1.1 3.3-3.2 0-3.5-4.4-4.5-4.4-6.5 0-.8.3-1.3 1.1-1.3.5 0 1.1.3 1.1 1.4l2.3-.4zm-12.4 4.5h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.6-1.1 1.6-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2h-.3zm0-5.6h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9h-.8v-3.8zm-11 7.6c0 1.8 1.6 3.3 3.4 3.3 1.8 0 3.2-1.5 3.3-3.3v-9.4h-2.2v9.5c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-9.5h-2.2l-.1 9.4zm-6.5-6.3c0-1 .3-1.4 1.1-1.4s1.1.5 1.1 1.4v6.4c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-6.4zm-2.1 6.5a3.4 3.4 0 0 0 3.5 3.2 3.4 3.4 0 0 0 3.2-3.2v-6.5a3.4 3.4 0 0 0-3.5-3.2 3.4 3.4 0 0 0-3.2 3.2v6.5zm-5.6 3h2.2V16.1h2.1v-1.9h-6.4v1.9h2.1v10.8zm-7.9 0V19l2.7 7.9h1.9V14.3h-1.9v7.2l-2.5-7.2h-2.1v12.6h1.9zm-7.9-2.9h2.4l.3 2.9h2.1l-2.4-12.6h-2.5l-2.4 12.6h2.1l.4-2.9zm1.1-7.3l1 5.4h-1.7l.7-5.4zm-5 1.8v-.9c0-1.9-1.1-3.5-3.2-3.5a3 3 0 0 0-3.3 2.7v6.9a3 3 0 0 0 2.9 3.2h.4c1.6.2 3-1 3.2-2.6v-1.9h-2.2V24c0 .8-.3 1.3-1.1 1.3s-1.1-.5-1.1-1.4v-6.4c0-1 .3-1.4 1.1-1.4.5 0 1.1.5 1.1 1.6v1l2.2-.2zm-8.9-4.2h-2.2v12.6h2.2V14.3zm-9 7.4h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.4-1.1 1.4-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2H99zm0-5.6h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9H99v-3.8zm-3.8 10.8V25h-3.8v-3.7h2.7v-1.9h-2.7v-3.2H95v-1.9h-5.7v12.6h5.9zM84.4 14.3l-1.6 7.3-1.6-7.3h-2.9v12.6h1.9V17l1.9 9.9h1.1l1.9-9.9v9.9h2.1V14.3h-2.8zm-12 9.7h2.4l.3 2.9h2.1l-2.4-12.6h-2.7l-2.4 12.6h2.1l.6-2.9zm1.3-7.3l1 5.4H73l.7-5.4z'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-footer__nav-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/who-we-are/our-advantage', className: 'c-nav-link t-link' },
	                'WHO WE ARE'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/what-we-offer/hotels-and-lodging', className: 'c-nav-link t-link' },
	                'WHAT WE OFFER'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/our-technology', className: 'c-nav-link t-link' },
	                'OUR TECHNOLOGY'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/careers', className: 'c-nav-link t-link' },
	                'CAREERS'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact', className: 'c-nav-link t-link' },
	                'CONTACT'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-footer__copyright' },
	          _react2.default.createElement(
	            'span',
	            null,
	            'AmericanTours International, LLC. \xA9 ',
	            new Date().getFullYear(),
	            '. All rights reserved.'
	          )
	        )
	      );
	    }
	  });
	};
	
	exports.default = Navbar;
	module.exports = exports['default'];

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(379);
	
	var _reactToggled = __webpack_require__(412);
	
	var _reactToggled2 = _interopRequireDefault(_reactToggled);
	
	var _jsCookie = __webpack_require__(42);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_React$Component) {
	  _inherits(Navbar, _React$Component);
	
	  function Navbar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderLogin = function () {
	      var sessionCookie = _jsCookie2.default.get('ATIWBESESSION');
	      if (sessionCookie) {
	        return _react2.default.createElement(
	          'a',
	          { href: '/wbe', className: 'c-navbar__login-btn t-link' },
	          _react2.default.createElement(
	            'span',
	            { className: 'min-tabletLg', style: { marginRight: 7, textTransform: "initial" } },
	            'ATI Connect'
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/login', className: 'c-navbar__login-btn t-link' },
	          _react2.default.createElement(
	            'span',
	            { className: 'min-tabletLg', style: { marginRight: 7 } },
	            'Login'
	          ),
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 30.595 12.238',
	              width: '24',
	              height: '24',
	              fill: 'currentColor'
	            },
	            _react2.default.createElement(
	              'g',
	              { transform: 'translate(-5 -22)' },
	              _react2.default.createElement('path', {
	                d: 'M-822,1194.358a6.119,6.119,0,0,1,6.119-6.119,6.12,6.12,0,0,1,5.564,3.569h16.362l2.55,2.55-2.55,2.55h-1.53l-1.53-1.02-1.529,1.02h-1.53l-1.53-1.02-1.53,1.02h-1.02l-1.53-1.02-1.529,1.02h-3.1a6.12,6.12,0,0,1-5.564,3.569A6.119,6.119,0,0,1-822,1194.358Zm2.55,0a1.53,1.53,0,0,0,1.529,1.53,1.53,1.53,0,0,0,1.53-1.53,1.53,1.53,0,0,0-1.53-1.53A1.53,1.53,0,0,0-819.45,1194.358Z',
	                transform: 'translate(827 -1165.238)'
	              })
	            )
	          )
	        );
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Navbar.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_reactRouterDom.Route, {
	      render: function render(_ref) {
	        var location = _ref.location;
	
	        var isHomePage = location.pathname === '/' || location.pathname === '/ati/';
	
	        return _react2.default.createElement(
	          _reactToggled2.default,
	          null,
	          function (_ref2) {
	            var on = _ref2.on,
	                getTogglerProps = _ref2.getTogglerProps,
	                setOff = _ref2.setOff;
	            return _react2.default.createElement(
	              'nav',
	              {
	                className: (0, _classnames2.default)('c-navbar', {
	                  't-context--dark': isHomePage,
	                  't-context--light': !isHomePage,
	                  'c-navbar--light': !isHomePage
	                })
	              },
	              _react2.default.createElement('button', _extends({
	                className: (0, _classnames2.default)('c-navbar__nav-btn', { 'is-open': on })
	              }, getTogglerProps())),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                  to: '/',
	                  className: 'c-navbar__logo t-link',
	                  activeClassName: 'active'
	                },
	                _react2.default.createElement(
	                  'svg',
	                  { viewBox: '0 0 193.2 48.2', width: 140, height: 35 },
	                  _react2.default.createElement('path', {
	                    fill: '#00304D',
	                    d: 'M50 31.7c0 .4-.4.8-.8.8h-1.7c-1.4-.2-3.1-1-3.1-3v-3.3c0-.4.4-.8.8-.8h3.9c.5 0 .8.4.8.8v5.5h.1zm12.3-19.3c1.2-1.3 1.8-3 1.9-4.8a8 8 0 0 0-16.1 0 8 8 0 0 0 1.1 4h-5.4v-10C43.8 1 42.5.5 41 .5h-7.1c-1.6 0-2.8.5-2.8 1.1v19.7A16.6 16.6 0 1 0 21.9 45c.2.5.6.9 1.1.9h38.2c.5 0 .9-.7.9-1.6V12.4h.2z'
	                  }),
	                  _react2.default.createElement('path', {
	                    fill: '#FFF',
	                    d: 'M58.7 43.9h-5.3c-.7 0-1.3-.9-1.3-2.1V17.4c0-1.1.4-2.1 1.3-2.1a7 7 0 0 0 5.3 0c.7 0 1.3.9 1.3 2.1v24.3c-.1 1.3-.6 2.2-1.3 2.2m0 0h-5.3c-.7 0-1.3-.9-1.3-2.1V17.4c0-1.1.4-2.1 1.3-2.1a7 7 0 0 0 5.3 0c.7 0 1.3.9 1.3 2.1v24.3c-.1 1.3-.6 2.2-1.3 2.2zm-9.1-9.2c-4.8.5-7.3-1.9-7.3-4.6V23h7c.3 0 .6-.6.6-1.4v-6.2c0-.7-.3-1.4-.6-1.4h-7V3.4c0-.6-.9-1-2-1h-5.1c-1.1 0-2 .5-2 1V30c0 14.1 14 14.7 16.5 14.4.2 0 .4 0 .4-.6 0-5 .3-8.3-.5-9.1m0 0c-4.8.5-7.3-1.9-7.3-4.6V23h7c.3 0 .6-.6.6-1.4v-6.2c0-.7-.3-1.4-.6-1.4h-7V3.4c0-.6-.9-1-2-1h-5.1c-1.1 0-2 .5-2 1V30c0 14.1 14 14.7 16.5 14.4.2 0 .4 0 .4-.6 0-5 .3-8.3-.5-9.1zm6.7-32.5a5.6 5.6 0 0 0-5.6 5.5 5.6 5.6 0 0 0 5.7 5.5c3-.1 5.5-2.5 5.5-5.5 0-3.1-2.5-5.5-5.6-5.5m0 0a5.6 5.6 0 0 0-5.6 5.5 5.6 5.6 0 0 0 5.7 5.5c3-.1 5.5-2.5 5.5-5.5 0-3.1-2.5-5.5-5.6-5.5zM31.1 29.3a14.6 14.6 0 1 0-14.7 14.5h.1c2.1 0 4.2-.5 6.1-1.4v.6c0 .5.5.9 1.3.9h6c.7 0 1.3-.4 1.3-.9l-.1-13.7m0 0a14.6 14.6 0 1 0-14.7 14.5h.1c2.1 0 4.2-.5 6.1-1.4v.6c0 .5.5.9 1.3.9h6c.7 0 1.3-.4 1.3-.9l-.1-13.7zm23.3-11.8l-.1.8v21.9c0 .8.2 1.6.5 1.6h2.8c.3 0 .5-.7.5-1.6V18.4l-.1-.8c-.6.2-1.2.2-1.9.2-.5 0-1.1 0-1.7-.3zm-6.6 19.3a7.4 7.4 0 0 1-7.6-7.2v-9.1h6.9c.3 0 .6-.3.6-.6v-2.7c0-.3-.3-.6-.6-.6h-6.9V5c0-.4-.4-.6-.7-.6h-3.2c-.4 0-.7.3-.7.6v23.5c.2 7.3 3.2 12.1 11.9 13.5.4.1.8-.1.8-.5 0-3.6.2-4.1-.5-4.7zm8.5-32.7c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6.1-2-1.5-3.6-3.5-3.6zm.9 40.3v.2h.5v1h.3v-1h.4v-.2h-1.2zm2.4 0l-.3.8-.2-.8h-.4v1.3h.2v-1l.3 1h.3l.3-1v1h.2v-1.3h-.4zM25.5 29.2l.1-.1h.2l-.1.1h-.2zm-.3 2.9l.1-.1-.1.1zm-.1.2l.1-.1-.1.1zm-1.5 5.2l.1-.1-.1.1zm-.5.2l.1-.1-.1.1zm-6.9-1.5h.1l.1-.1-.2.1zm-8.7-4.6v.1-.1zm-.3-.7l.1.1-.1-.1zm17.1-3l-.1-.1.1.1zm-.1.1l-.1.1.1-.1zm-1.6 3.3l-.1.1.1-.1zm-6.8-4.4zm11.7-.3v-.2h-.2v-.1h-.1l-.1-.3-.1-.3-.2-.1v.1h-.3l-.3.1v.7H26v.1l-.6.1-.5.1h-.1l-.1.1-.2.1v.1l-.1.1.1-.1V27l-.1.1h-.1l-.2.1H24l.1.1h-.4l-.4.2-.1.1-.1.5h.3v.3l-.1.1-.1.1-.1.1H23l.1-.1.1-.1.1-.1.1-.1h-.5l-.1.1h-.2l-.1.1v.1H22v-.2h.2V27.8l-.3.2h-.1l-.1.1v.1-.2l.1-.1v-.5h-.1l-.4-.2h-.4v.2-.1l-.1.1v.5l.1.1v.4l-.1.2-.1.1v.1l-.2.4-.1.1h-.1v-.1l-.1-.2v-.6l.1-.1v-.6l.1-.1v-.2l-.1.1v.2l-.1.1v-.2l.1-.2.1-.1h.1v.1l.1-.1h.2v-.1h.4V27H21v-.1h-.9l-.1-.1v-.1l-.1-.1h-.1v-.1l.1-.1h-.2l-.1.1-.1.1h-.1l-.1.1H19l-.1.1h-.2v-.2l-.2.1h-.2v-.1l.2-.2.3-.2h.1l.1-.1h-.7V26h-.5v-.1l-.1-.2v.2h-2.2l-.8-.7-.3-.1H14l-.3-.1-.3-.1-.3-.1-.3-.1h-.2l-.3-.1-.3-.1-.3-.1-.4-.1-.6-.2-.5-.1-.2-.1-.2-.1-.3-.1-.3-.1-.3-.1v.5l-.2.1h-.1V24l.1-.1v-.1h-.1l-.1-.1h-.3l-.1-.1v-.1V24.3v-.1.1l.1.1.1.1-.1-.1h-.1v.2l-.4.5-.1.1-.1.3v.1l-.1.1h-.1l-.1.1v.2l-.1.2v.4l-.1.1-.1.1-.1.4h-.1v1.1l.1.2V28.8v-.1h.1l.1.2h-.1v.1-.2.4H7v.2h-.1v.1l.1.2v.2l.1.1v.4l.1.1.1.3v.2l.1.1v.2h.1l.1.1v.1l.1.1v.5l.9.2 1.4 1 .8.2.3.1v-.2l.7.1.1.1v.1l.1.1v.2l.1.2.2.2.1.4.1.2.1.1.2.2.2.1.2-.3h.5l.1.1.1.1v.1l.1.1.1.4.1.2.1.2.1.1.1.4.1.2.1.1h.1l.1.1h.2l.2.1h.1V36.4h.1v-.1h.2v.1l.1-.1h.2l.1-.1v-.3.1h.1l.2-.1h.4l.2.1h.5l.1.1v.1h.1l.1.1h.6l.1-.1h.2l.1.1h.2v-.1l.5-.8h-.1v-.1l.1-.1v-.1h-.1V35h-.2l-.1-.1v-.1h.5l.1-.1h.4l.1-.2v.2h.2l.1-.1v.1h.5l.2.1v.1h.2l.1-.1h.3l.1.1v.1l.1.1h.2v.6-.1.4l.1.1.1.1v.1h.1l.1.2v.1h.2l.1-.1h.1v-1.2l-.1-.1v-.4l-.2-.2-.1-.3.4.5v-.4l.1-.2V34h.3l.2-.2v-.1h.1V33.4l.1-.1h.1l.1-.1v-.1l.1-.1.1-.1h.1l.1-.1V32.5h-.2v-.2.1h.1v.1-.6h-.2v-.1H24v-.3l.1-.1v-.1V31.6h.2v.5-.2l.1-.2v-.3l.7-1-.1-.2-.1-.2v-.1h.6v.1V29.1h.1l.1-.1h.3l.2-.1.1-.1v-.1.1h.1l.1-.1h.1l.1-.1v-.1.1h-.2v-.2h-.1v-.1l-.1-.1v-.1l.1-.1v-.7h.1v-.1h.1l.8-.4.1-.2z'
	                  }),
	                  _react2.default.createElement('path', {
	                    fill: '#E11F32',
	                    d: 'M29.1 29.2a12.2 12.2 0 0 0-12.3-12A12 12 0 0 0 4.6 29a12 12 0 0 0 11.8 12.2h.5a13 13 0 0 0 6.7-1.9v2.5l.1.1h5.2l.1-.1v-11l.1-1.6m25.3-11.7l-.1.8v21.9c0 .8.2 1.6.5 1.6h2.8c.3 0 .5-.7.5-1.6V18.4l-.1-.8c-.6.2-1.2.2-1.9.2-.5 0-1.1 0-1.7-.3m-6.6 19.3a7.4 7.4 0 0 1-7.6-7.2v-9.1h6.9c.3 0 .6-.3.6-.6v-2.7c0-.3-.3-.6-.6-.6h-6.9V5c0-.4-.4-.6-.7-.6h-3.2c-.4 0-.7.3-.7.6v23.5c.2 7.3 3.2 12.1 11.9 13.5.4.1.8-.1.8-.5 0-3.6.1-4.1-.5-4.7m8.5-32.7c-2 0-3.5 1.6-3.5 3.6s1.6 3.6 3.5 3.6c2 0 3.5-1.6 3.5-3.6.1-2-1.5-3.6-3.5-3.6M29.1 29.2a12.2 12.2 0 0 0-12.3-12A12 12 0 0 0 4.6 29a12 12 0 0 0 11.8 12.2h.5a13 13 0 0 0 6.7-1.9v2.5l.1.1h5.2l.1-.1v-11l.1-1.6z'
	                  }),
	                  _react2.default.createElement('path', {
	                    fill: '#FFF',
	                    d: 'M25.499999999999996 29.200000000000003l.1-.1h.2l-.1.1h-.2zm-.3 2.9l.1-.1-.1.1zm-.1.2l.1-.1-.1.1m-1.5 5.2l.1-.1-.1.1m-.5.2l.1-.1-.1.1m-6.9-1.5h.1l.1-.1-.2.1zm-8.6-4.8zm-.1.2v.1-.1m-.3-.7l.1.1-.1-.1M24.3 27.9l-.1-.1.1.1zm-.1.1l-.1.1.1-.1zm-1.6 3.3l-.1.1.1-.1zm-6.8-4.4zm11.7-.3v-.2h-.2v-.1h-.1l-.1-.3-.1-.3-.2-.1v.1h-.3l-.3.1v.7H26v.1l-.6.1-.5.1h-.1l-.1.1-.2.1v.1l-.1.1.1-.1V27l-.1.1h-.1l-.2.1H24l.1.1h-.4l-.4.2-.1.1-.1.5h.3v.3l-.1.1-.1.1-.1.1H23l.1-.1.1-.1.1-.1.1-.1h-.5l-.1.1h-.2l-.1.1v.1H22v-.2h.2V27.8l-.3.2h-.1l-.1.1v.1-.2l.1-.1v-.5h-.1l-.4-.2h-.4v.2-.1l-.1.1v.5l.1.1v.4l-.1.2-.1.1v.1l-.2.4-.1.1h-.1v-.1l-.1-.2v-.6l.1-.1v-.6l.1-.1v-.2l-.1.1v.2l-.1.1v-.2l.1-.2.1-.1h.1v.1l.1-.1h.2v-.1h.4V27H21v-.1h-.9l-.1-.1v-.1l-.1-.1h-.1v-.1l.1-.1h-.2l-.1.1-.1.1h-.1l-.1.1H19l-.1.1h-.2v-.2l-.2.1h-.2v-.1l.2-.2.3-.2h.1l.1-.1h-.7V26h-.5v-.1l-.1-.2v.2h-2.2l-.8-.7-.3-.1H14l-.3-.1-.3-.1-.3-.1-.3-.1h-.2l-.3-.1-.3-.1-.3-.1-.4-.1-.6-.2-.5-.1-.2-.1-.2-.1-.3-.1-.3-.1-.3-.1v.5l-.2.1h-.1V24l.1-.1v-.1h-.1l-.1-.1h-.3l-.1-.1v-.1V24.3v-.1.1l.1.1.1.1-.1-.1h-.1v.2l-.4.5-.1.1-.1.3v.1l-.1.1h-.1l-.1.1v.2l-.1.2v.4l-.1.1-.1.1-.1.4h-.1v1.1l.1.2V28.8v-.1h.1l.1.2h-.1v.1-.2.4H7v.2h-.1v.1l.1.2v.2l.1.1v.4l.1.1.1.3v.2l.1.1v.2h.1l.1.1v.1l.1.1v.5l.9.2 1.4 1 .8.2.3.1v-.2l.7.1.1.1v.1l.1.1v.2l.1.2.2.2.1.4.1.2.1.1.2.2.2.1.2-.3h.5l.1.1.1.1v.1l.1.1.1.4.1.2.1.2.1.1.1.4.1.2.1.1h.1l.1.1h.2l.2.1h.1V36.4h.1v-.1h.2v.1l.1-.1h.2l.1-.1v-.3.1h.1l.2-.1h.4l.2.1h.5l.1.1v.1h.1l.1.1h.6l.1-.1h.2l.1.1h.2v-.1l.5-.8h-.1v-.1l.1-.1v-.1h-.1V35h-.2l-.1-.1v-.1h.5l.1-.1h.4l.1-.2v.2h.2l.1-.1v.1h.5l.2.1v.1h.2l.1-.1h.3l.1.1v.1l.1.1h.2v.6-.1.4l.1.1.1.1v.1h.1l.1.2v.1h.2l.1-.1h.1v-1.2l-.1-.1v-.4l-.2-.2-.1-.3.4.5v-.4l.1-.2V34h.3l.2-.2v-.1h.1V33.4l.1-.1h.1l.1-.1v-.1l.1-.1.1-.1h.1l.1-.1V32.5h-.2v-.2.1h.1v.1-.6h-.2v-.1H24v-.3l.1-.1v-.1V31.6h.2v.5-.2l.1-.2v-.3l.7-1-.1-.2-.1-.2v-.1h.6v.1V29.1h.1l.1-.1h.3l.2-.1.1-.1v-.1.1h.1l.1-.1h.1l.1-.1v-.1.1h-.2v-.2h-.1v-.1l-.1-.1v-.1l.1-.1v-.7h.1v-.1h.1l.8-.4m0-.1'
	                  }),
	                  _react2.default.createElement('path', {
	                    className: 'c-navbar__logo-type',
	                    fill: 'currentColor',
	                    d: 'M193.2 37.7v-1c0-1.9-1.1-3.5-3.2-3.5a3 3 0 0 0-3.3 2.7V43a3 3 0 0 0 2.9 3.2h.4c1.6.2 3-1 3.2-2.6v-1.9H191v1.6c0 .8-.3 1.3-1.1 1.3s-1.1-.5-1.1-1.4v-6.4c0-1 .3-1.4 1.1-1.4.5 0 1.1.5 1.1 1.6v1h2.2zm-7.8 8.3v-1.9h-3.3V33.4h-2.2V46h5.5zm-6.8 0v-1.9h-3.3V33.4H173V46h5.6zm-11.3-2.1h-2.1V46h.8l-.8 2.2h1l1.3-2.2v-2.1h-.2zm-3.2 2.1v-1.9h-3.3V33.4h-2.2V46h5.5zm-11.4-2.7h2.4l.3 2.9h2.1l-2.4-12.6h-2.7L150 46.1h2.1l.6-2.8zm1.1-7.3l1 5.4H153l.8-5.4zm-9.5 10v-8l2.7 8h1.9V33.4H147v7.2l-2.5-7.2h-2.1V46h1.9zm-8.4-9.4c0-1 .3-1.4 1.1-1.4s1.1.5 1.1 1.4V43c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-6.4zm-2.3 6.4a3.4 3.4 0 0 0 3.5 3.2 3.4 3.4 0 0 0 3.2-3.2v-6.5a3.4 3.4 0 0 0-3.5-3.2 3.4 3.4 0 0 0-3.2 3.2V43zm-2.4-9.6H129V46h2.2V33.4zM123.3 46h2.2V35.3h2.1v-1.9h-6.4v1.9h2.1V46zm-6.7-2.7h2.4l.3 2.9h2.1L119 33.6h-2.7L114.2 46h2.1l.3-2.7zm1.3-7.3l1 5.4h-1.7l.7-5.4zm-9.5 10v-8l2.7 7.9h1.9V33.4h-1.9v7.2l-2.5-7.2h-2.1V46h1.9zm-8.6-5.1h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.4-1.1 1.4-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2h-.1zm0-5.7h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9h-.8v-3.8zM96 46v-1.9h-3.8v-3.7h2.7v-1.9h-2.7v-3.2h3.7v-1.9h-5.7V46H96zm-11.5 0h2.2V35.3h2.1v-1.9h-6.4v1.9h2.1V46zm-7.9 0v-8l2.7 7.9h1.9V33.4h-1.9v7.2l-2.5-7.2h-2.2V46h2zm-4.5-12.6h-2.2V46h2.2V33.4zm102.1-16.2a3 3 0 0 0-3-3c-2.1 0-3.3 1.1-3.3 3.2 0 3.7 4.4 4.3 4.4 6.8 0 .8-.5 1.1-1.3 1.1-.6 0-1.3-.6-1.3-1.9l-2.1.3c.2 1.9 1.3 3.5 3.2 3.5 2.1 0 3.3-1.1 3.3-3.2 0-3.5-4.4-4.5-4.4-6.5 0-.8.3-1.3 1.1-1.3.5 0 1.1.3 1.1 1.4l2.3-.4zm-12.4 4.5h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.6-1.1 1.6-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2h-.3zm0-5.6h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9h-.8v-3.8zm-11 7.6c0 1.8 1.6 3.3 3.4 3.3 1.8 0 3.2-1.5 3.3-3.3v-9.4h-2.2v9.5c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-9.5h-2.2l-.1 9.4zm-6.5-6.3c0-1 .3-1.4 1.1-1.4s1.1.5 1.1 1.4v6.4c0 1-.3 1.4-1.1 1.4s-1.1-.5-1.1-1.4v-6.4zm-2.1 6.5a3.4 3.4 0 0 0 3.5 3.2 3.4 3.4 0 0 0 3.2-3.2v-6.5a3.4 3.4 0 0 0-3.5-3.2 3.4 3.4 0 0 0-3.2 3.2v6.5zm-5.6 3h2.2V16.1h2.1v-1.9h-6.4v1.9h2.1v10.8zm-7.9 0V19l2.7 7.9h1.9V14.3h-1.9v7.2l-2.5-7.2h-2.1v12.6h1.9zm-7.9-2.9h2.4l.3 2.9h2.1l-2.4-12.6h-2.5l-2.4 12.6h2.1l.4-2.9zm1.1-7.3l1 5.4h-1.7l.7-5.4zm-5 1.8v-.9c0-1.9-1.1-3.5-3.2-3.5a3 3 0 0 0-3.3 2.7v6.9a3 3 0 0 0 2.9 3.2h.4c1.6.2 3-1 3.2-2.6v-1.9h-2.2V24c0 .8-.3 1.3-1.1 1.3s-1.1-.5-1.1-1.4v-6.4c0-1 .3-1.4 1.1-1.4.5 0 1.1.5 1.1 1.6v1l2.2-.2zm-8.9-4.2h-2.2v12.6h2.2V14.3zm-9 7.4h1.1l1.6 5.2h2.2l-1.7-5.7c.8-.3 1.4-1.1 1.4-3.2 0-2.7-1.3-3.7-3.7-3.7h-3v12.6h2.2v-5.2H99zm0-5.6h.8c1.1 0 1.6.5 1.6 1.9s-.5 1.9-1.6 1.9H99v-3.8zm-3.8 10.8V25h-3.8v-3.7h2.7v-1.9h-2.7v-3.2H95v-1.9h-5.7v12.6h5.9zM84.4 14.3l-1.6 7.3-1.6-7.3h-2.9v12.6h1.9V17l1.9 9.9h1.1l1.9-9.9v9.9h2.1V14.3h-2.8zm-12 9.7h2.4l.3 2.9h2.1l-2.4-12.6h-2.7l-2.4 12.6h2.1l.6-2.9zm1.3-7.3l1 5.4H73l.7-5.4z'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                {
	                  className: (0, _classnames2.default)('c-navbar__nav', { 'is-open': on }),
	                  onClick: setOff
	                },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/who-we-are/our-advantage',
	                      className: 'c-nav-link t-link',
	                      activeClassName: 'active'
	                    },
	                    'WHO WE ARE'
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: (0, _classnames2.default)('c-navbar__subnav', {
	                        visible: location.pathname.indexOf('who-we-are') >= 0
	                      })
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/who-we-are/our-advantage',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Our Advantage'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/who-we-are/our-mission',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Our Mission'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/who-we-are/why-ati',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Why ATI'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/who-we-are/whats-new',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'What\'s New'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/what-we-offer/hotels-and-lodging',
	                      className: 'c-nav-link t-link',
	                      activeClassName: 'active'
	                    },
	                    'WHAT WE OFFER'
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    {
	                      className: (0, _classnames2.default)('c-navbar__subnav', {
	                        visible: location.pathname.indexOf('what-we-offer') >= 0
	                      })
	                    },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/what-we-offer/hotels-and-lodging',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Hotels & Lodging'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/what-we-offer/escorted-tours',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Escorted Tours'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/what-we-offer/airtours',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Air Tours'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/what-we-offer/drive-america',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'DriveAmerica\u2122'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/what-we-offer/attractions-and-transportation',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Attractions & Transportation'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        {
	                          to: '/what-we-offer/group-travel',
	                          className: 'c-nav-link c-nav-link--sub t-subnav-link',
	                          activeClassName: 'active'
	                        },
	                        'Group Travel'
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/our-technology',
	                      className: 'c-nav-link t-link',
	                      activeClassName: 'active'
	                    },
	                    'OUR TECHNOLOGY'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/careers',
	                      className: 'c-nav-link t-link',
	                      activeClassName: 'active'
	                    },
	                    'CAREERS'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      to: '/contact',
	                      className: 'c-nav-link t-link',
	                      activeClassName: 'active'
	                    },
	                    'CONTACT'
	                  )
	                )
	              ),
	              _this2.renderLogin()
	            );
	          }
	        );
	      }
	    });
	  };
	
	  return Navbar;
	}(_react2.default.Component);
	
	exports.default = Navbar;
	module.exports = exports['default'];

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _componentComponent = __webpack_require__(73);
	
	var _componentComponent2 = _interopRequireDefault(_componentComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollToTop = function ScrollToTop() {
	  return _react2.default.createElement(
	    _reactRouterDom.Route,
	    null,
	    function (props) {
	      return _react2.default.createElement(_componentComponent2.default, _extends({}, props, {
	        didUpdate: function didUpdate(_ref) {
	          var prevProps = _ref.prevProps;
	
	          props.location.pathname !== prevProps.location.pathname && window.scrollTo(0, 0);
	        }
	      }));
	    }
	  );
	};
	
	exports.default = ScrollToTop;
	module.exports = exports['default'];

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ScrollToTop = __webpack_require__(186);
	
	var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);
	
	var _Navbar = __webpack_require__(182);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Footer = __webpack_require__(181);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(381);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_ScrollToTop2.default, null),
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: 'Home',
	        titleTemplate: '%s | ' + data.site.siteMetadata.title,
	        meta: [{
	          name: 'description',
	          content: 'North America’s leading travel service provider.'
	        }]
	      },
	      _react2.default.createElement('link', {
	        href: 'https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700',
	        rel: 'stylesheet'
	      })
	    ),
	    _react2.default.createElement(_Navbar2.default, null),
	    children(),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-775fa8cac77787ccb4d4.js